import React from 'react';
import {Avatar, List, ListItemAvatar, ListItemButton, ListItemText} from "@mui/material";
import {deepPurple} from "@mui/material/colors";
import ColoredAvatar from "../../../utils/ColoredAvatar";

const LeadListingItem = (props) => {
    const handleOnClick = () => {props.onLeadChange(props.id)}

    return (
        <List dense={false} sx={{borderBottom:'1px solid #f0f0f0'}}  disablePadding>
            <ListItemButton onClick={handleOnClick} selected={(props.active === props.id)? true : false}>
                <ListItemAvatar>
                    <ColoredAvatar letter={props.name.slice(0,1).toString().toUpperCase()}/>
                </ListItemAvatar>
                {props.companyName !== null ?
                    <ListItemText primary={props.name + " - " + props.companyName}/>
                    :
                    <ListItemText primary={props.name}/>
                }
            </ListItemButton>
        </List>
    );
};

export default LeadListingItem;
